var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.items
    ? _c(
        "b-dropdown",
        {
          key: _vm.filterKey,
          staticClass: "filter-dropdown",
          attrs: {
            id: _vm.filterId,
            size: "sm",
            "toggle-class": _vm.filterClass,
          },
          scopedSlots: _vm._u(
            [
              {
                key: "button-content",
                fn: function () {
                  return [
                    _vm._v(
                      "\n    " +
                        _vm._s(_vm.$t("FILTER." + _vm.filterName + ".TITLE")) +
                        "\n    "
                    ),
                    _vm.values.length != 0
                      ? _c("span", [
                          _vm._v("(" + _vm._s(_vm.values.length) + ")"),
                        ])
                      : _vm._e(),
                  ]
                },
                proxy: true,
              },
            ],
            null,
            false,
            1854025844
          ),
        },
        [
          _c(
            "b-dropdown-form",
            [
              _c(
                "b-form-checkbox",
                {
                  attrs: { switch: "", size: "sm", name: "", value: "" },
                  model: {
                    value: _vm.values,
                    callback: function ($$v) {
                      _vm.values = $$v
                    },
                    expression: "values",
                  },
                },
                [_vm._v(" Ingen status")]
              ),
            ],
            1
          ),
          _vm._l(_vm.items, function (ix) {
            return _c(
              "b-dropdown-form",
              { key: ix },
              [
                _c(
                  "b-form-checkbox",
                  {
                    attrs: {
                      switch: "",
                      size: "sm",
                      name: "check-button",
                      value: ix,
                    },
                    model: {
                      value: _vm.values,
                      callback: function ($$v) {
                        _vm.values = $$v
                      },
                      expression: "values",
                    },
                  },
                  [_vm._v(_vm._s(ix))]
                ),
              ],
              1
            )
          }),
          _vm.amount != 0 ? _c("b-dropdown-divider") : _vm._e(),
          _vm.amount.length != 0
            ? _c("b-dropdown-item", { on: { click: _vm.clearFilter } }, [
                _vm._v(_vm._s(_vm.$t("FILTER.CLEAR_SELECTED"))),
              ])
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }